import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerCreateVirtualProductGroup(id: string, name: string, virtualPackId: string) {
	logGoogleTagManagerEvent({
		event: 'cogvio.groupCreateFromVirtualPack',
		groupCreate: {
			id,
			name,
			virtualPackId,
		},
	});
}
